// 가격수량 변경

import BaseModal from "components/modal/base";
import { priceFormat, regNum } from "components/utils/comm";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useUpdateCnt } from "./handlers";
import { useCalendarCardInfContext } from "../context";
import i18n from "locales/i18n";
import { langProps } from "interface/index";

type IProps = {
  isOpen: boolean;
  onClose: () => void;
};
export default function RoomCountModal({ isOpen, onClose }: IProps) {
  const { t } = useTranslation();
  const langCd = i18n.language;
  const [rmCt, setRmCt] = useState("");
  const { onUpdateCnt } = useUpdateCnt();
  const { cardInf } = useCalendarCardInfContext();
  const txtRef = useRef<HTMLParagraphElement | null>(null);
  const txt = {
    ko: `현재 상품 생성수량은 <b class='text-red-500 text-sm px-1'> ${cardInf?.sellCt} 개</b>입니다. <br />`,
    en: `The current product creation quantity is <b class='text-red-500 text-sm px-1'>${cardInf?.sellCt} units</b>. <br />`,
  };

  useEffect(() => {
    if (txtRef.current) {
      txtRef.current.innerHTML = txt[langCd as keyof langProps];
    }
  }, [txt, langCd]);

  return (
    <>
      <BaseModal isOpen={isOpen} title={t("md_ttl_edit_cnt")} onClose={onClose}>
        <div className="text-center font-bold">
          <p className="text-xs" ref={txtRef} />
          <div className="flex justify-center pt-3">
            <label htmlFor="" className="w-[70px] font-bold">
              {t("txt_rm_ct")} :
            </label>
            <input
              type="text"
              name="sellPri"
              className="h-[28px] flex-1"
              maxLength={20}
              defaultValue={""}
              onChange={(e) => {
                const value = e.currentTarget.value.replace(/[₩,]/g, "");
                if (!regNum.test(value)) {
                  return (e.currentTarget.value = "");
                }

                e.currentTarget.value =
                  priceFormat({ price: value, currSymbol: false }) || "";
                setRmCt(e.currentTarget.value);
              }}
            />
          </div>
        </div>
        <div className="flex justify-center pt-5">
          <button className="btn bg-red-400" onClick={() => onUpdateCnt(rmCt)}>
            변경
          </button>
        </div>
      </BaseModal>
    </>
  );
}
